export default __webpack_public_path__ + "static/media/solid_main_icon.4743e726.png";